<div class="lightbox-container">
  <button mat-icon-button class="close-btn" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
  @if (data?.images[this.data.currentIndex]?.type === 'image' && showZoom) {
    <pinch-zoom
      [doubleTap]="true"
      [minScale]="1"
      >
      <img [src]="data?.src" alt="Image" class="lightbox-img" />
    </pinch-zoom>
  }

  @if (data.images[this.data.currentIndex]?.type === 'video') {
    <iframe
      width="70%"
      height="70%"
      [src]="safeSrc | safeUrl"
      >
    </iframe>
  }

  <button mat-icon-button class="prev-btn" (click)="prevImage()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <button mat-icon-button class="next-btn" (click)="nextImage()">
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>
